<template>
    <div class="container my-2">
        <div class="row">
            <div class="offset-2 col-md-10">
                <div class="card" id="div-form">
                <div class="card-body">
                    <h4 class="panel-heading mb-4">Artikel Erstellen</h4>
                        <div class="card-body" id="div-form">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="col-md-4" for="asin">EAN</label>  
                                    <b-input
                                        class="form-control"
                                        id="ean"
                                        name="ean"
                                        placeholder="EAN"
                                        v-model="ean"
                                        :state="validateEan"
                                    ></b-input>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="col-md-4" for="asin">ASIN</label>                                                                          
                                    <b-input
                                        class="form-control"
                                        id="asin"
                                        name="asin"
                                        v-model="asin"
                                        :state="validateAsin"
                                    ></b-input>
                                </div>
                            </div>
                            <div v-if="isQAsin">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="col-md-4" for="name">Produktname</label>                                      
                                        <b-input
                                            class="form-control"
                                            id="name"
                                            v-model="name"
                                            :state="validateName"
                                        ></b-input>
                                    </div>
                                </div>
                                <div  class="col-md-12">
                                    <div class="form-group">
                                        <label class="col-md-4" for="category">Kategorie</label>
                                        <b-form-select
                                            id="category"       
                                            v-model="selectedCategory"                               
                                            :options="categoryOptions"
                                            optionLabel="text"
                                            optionValue="value"
                                            placeholder="Kategorien"
                                            :state="validateCategory">
                                        </b-form-select>
                                    </div>
                                </div>
                                <!--Volumen-->                           
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <b-row class="mx-1">
                                            <label class="col-md-4" for="length">Länge</label>
                                            <label class="col-md-4" for="width">Breite</label>
                                            <label class="col-md-4" for="height">Höhe</label>
                                        </b-row>
                                        <b-row class="m-0">
                                            <b-input
                                                class="form-control col-md-4"
                                                id="length"
                                                v-model="length"
                                                :state="validateLength"
                                            ></b-input>
                                            <b-input
                                                class="form-control col-md-4"
                                                id="width"
                                                v-model="width"
                                                :state="validateWidth"
                                            ></b-input>
                                            <b-input
                                                class="form-control col-md-4"
                                                id="height"
                                                v-model="height"
                                                :state="validateHeight"
                                            ></b-input>
                                        </b-row>
                                    </div>
                                </div>
                                <!-- Gewicht -->
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="col-md-4" for="manualWeight">Manuelles Gewicht</label>                                   
                                        <b-input
                                            class="form-control col-md-4"
                                            id="manualWeight"
                                            v-model="manualWeight"
                                            :state="validateManualWeight"
                                        ></b-input>
                                    </div>
                                </div>                                                                                    
                            </div>
                            <div class="col-md-12">
                                <b-button
                                    type="submit"
                                    class="btn btn-primary btn-primary float-right"
                                    @click="create()"
                                    :disabled="isDuplicate">
                                    Erstellen
                                </b-button>
                                <b-alert v-if="isDuplicate" show variant="warning">Ein Job mit dieser EAN- und ASIN-Kombination existiert bereits.</b-alert>
                            </div>
                        </div>
                </div>
                </div>

                <div class="card mt-3" id="div-job-table">
                <div class="card-body">
                    <b-table
                        class="mt-3"
                        :items="jobs"
                        :fields="fields"
                        :tbody-tr-class="rowClass"
                        striped hover small
                    >
                        <template v-slot:cell(updated_at)="row" class="col-3">
                            <div v-if="row.item.materialId">{{ moment(row.item.updated_at).format('DD.MM.YYYY HH:mm') }}</div>
                            <div v-else>-</div>
                        </template>
                    </b-table>
                </div>
                </div>
            </div>
        </div>
        <modal-error-component v-model="modalError"></modal-error-component>
    </div>
</template>
<script>
export default {
  name: "MaterialCreate",
  props: ["productCategories"],
    data() {
        return {
            ean: "",
            asin: "",
            isDuplicate: false,
            jobs: [],
            users: [],
            currentUser: null,
            fields: [
                { key: "asin", label: "ASIN", sortable: true },
                { key: "ean", label: "EAN", sortable: true },
                //, { key: "requestJobId", label: "Request Job", sortable: true }
                { key: "created_at", label: "Erstellt am", formatter: s => {this.createdAtFormatter(s)}, sortable: true },
                { key: "updated_at", label: "Fertiggestellt am", sortable: true },
                { key: "userId", label: "Benutzer", sortable: true, formatter: userId => (this.users.length == 0) ? '' : this.users.find(user => user.id == userId).name },
            ],
            name: "",
            selectedCategory: null,
            length: "",
            width: "",
            height: "",
            marketWeight: "",
            vendorWeight: "",
            manualWeight: "",
            baseWeight: "",
            volumneWeight: "",
            shippingWeight: "",
            categoryOptions : [],
            modalError: {
                show: false,
                message: "unpopulated",
                error: "unpopulated",
                title: "unpopulated"
            },           
        }
    },
  computed: {
        validateEan: function() {
            this.checkIsDuplicate();
            return /^\d+$/.test(this.ean)
            && [12,13].includes(this.ean.length);
        },
        validateAsin: function() {
            this.checkIsDuplicate();
            return /(^[A-Z0-9]{10})$/.test(this.asin);
        },
        validateName: function() {
            return this.name != ''
        },
        validateCategory: function(){
            return !isNaN(this.selectedCategory) && this.selectedCategory != null
        },
        validateLength: function(){
            return !isNaN(this.length) && this.length > 0 && this.length < 1000
        },
        validateWidth: function(){
            return !isNaN(this.width) && this.width > 0 && this.width < 1000
        },
        validateHeight: function(){
            return !isNaN(this.height) && this.height > 0 && this.height < 1000
        },
        validateVolumne: function(){
            return this.validateLength && this.validateWidth && this.validateHeight
        },        
        validateManualWeight: function(){
            return !isNaN(this.manualWeight) && this.manualWeight > 0 && this.manualWeight < 100000
        },
        submittable: function() {
          if(this.isQAsin){
            return this.validateEan
                && this.validateAsin
                && !this.isDuplicate
                && this.validateName
                && this.validateCategory
                && this.validateVolumne
                && this.validateManualWeight
          } else {
            return this.validateEan && this.validateAsin && !this.isDuplicate
          }
        },
        isQAsin(){
            if(this.asin.charAt(0) === "Q"){
                return true
            } else {
                return false
            }
        }
  },
  methods: {
        createdAtFormatter(s){
            if(!s) {
                return "‒"
            } else if (s == "__now__"){
                return "jetzt"
            }else{
                return moment(s).format('DD.MM.YYYY HH:mm');
            }
        },
        validateVolumneValue(value){
            return (isNaN(value) && value > 0 && value < 1000)
        },
        checkIsDuplicate() {
            // for some reason isDuplicate defined as a computed prop doesn't work, reactivity is broken.
            if(this.jobs.find( job => { return job.ean == this.ean && job.asin == this.asin })) {
                this.isDuplicate = true;
            }else{
                this.isDuplicate = false;
            }
        },
        rowClass(item, type) {
            if (!item || type !== 'row') return;
            if (item.created_at === '__now__') return 'table-success';
        },
        create() {
            if(!this.submittable) {
                this.$bvToast.toast( "ASIN, EAN oder ein Anderer Wert ist ungültig", {
                title: "Material Create",
                autoHideDelay: 2500,
                appendToast: false,
                variant: 'danger'
                });
                return;
            }
            let request = {};

            if(this.isQAsin){
                request = { 
                    ean: this.ean,
                    asin: this.asin,
                    productData: {
                        eans            : this.ean,
                        asin            : this.asin,
                        name            : this.name,
                        category        : this.selectedCategory ,
                        length          : Number(this.length),
                        width           : Number(this.width),
                        height          : Number(this.height),
                        manual_weight   : this.manualWeight     ? this.manualWeight : null,
                    },
                    isQAsin         : this.isQAsin,
                }
            } else {
                request = {
                    ean: this.ean,
                    asin: this.asin
                }
            }
            axios.post("/material/create_new_material", request).then( response => {
                this.$bvToast.toast( "Material Erstellt", {
                    title: "Material Create",
                    autoHideDelay: 20500,
                    appendToast: false,
                    variant: 'success',
                });
                this.jobs.unshift({
                    id: null,
                    created_at: "__now__",
                    updated_at: null,
                    asin: this.asin,
                    ean: this.ean,
                    userId: this.currentUser.id
                });

            //apparently the response object is not the job but the mds job
            //prepend object
            // this.jobs.unshift({
            //    id: response.data.id,
            //    created_at:   response.data.createdAt,
            //    updated_at:   response.data.updatedAt,
            //    asin:         response.data.asin,
            //    ean:          response.data.ean,
            //    state:        response.data.state,
            //    userId:       null,
            //    requestJobId: response.data.requestJobId
            // });
                this.ean = "";
                this.asin = "";
            }).catch( error => {
                console.error(error);
                this.modalError = {
                    show: true,
                    message: "Operation konnte nicht durgeführt werden.",
                    error: error.response?.data?.message ?? error.response?.data ?? error.message ?? error,
                    title: "Ein Fehler ist aufgetreten"
                }; 
            });
        }
    },
    created() {
				this.categoryOptions = Object.values(this.productCategories).map(category => { return {
					value: category.categoryId,
					text: category.uiName
				}});

        Promise.all([
            axios.get('get_material_create_requests')
        , axios.get('/user/all')
        , axios.get('/user/self')
        ]).then( ([_jobs, _users, _currentUser]) => {
            this.jobs = _jobs.data.sort((v, w) => w.created_at.localeCompare(v.created_at) )
            this.users = _users.data;
            this.currentUser = _currentUser.data;
        });
    }
}
</script>
